import { classNames } from "primereact/utils";
import { IBreakTypeInputModel } from "../models/breakTypeInputModel";
import styles from "./BreakTypeListItem.module.scss";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";

interface IBreakTypeListItemProps {
  className?: string;
  item?: IBreakTypeInputModel;
  isLoading: boolean;
  actionButtons?: React.ReactNode;
}

export const BreakTypeListItem = ({
  className,
  item,
  isLoading,
  actionButtons,
}: IBreakTypeListItemProps) => {
  const formatDuration = (minutes?: number) => {
    if (!minutes) return "";
    if (minutes < 60) return `${minutes} мин`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0
      ? `${hours}ч ${remainingMinutes}м`
      : `${hours}ч`;
  };

  return (
    <div
      className={classNames(className, styles.item, {
        [styles.item_deleted]: item?.isDeleted,
      })}
    >
      <div className={styles.item_skeleton_wrapper}>
        <SkeletonItem
          isLoading={isLoading}
          value={
            <div className={styles.item_wrapper}>
              <div
                className={styles.item_main_colorIndicator}
                style={{ backgroundColor: `#${item?.color}` }}
              />
              <div className={styles.item_main}>
                <div className={styles.item_main_name}>
                  {item?.name}
                  <span className={styles.item_main_name_id}>
                    (ID: {item?.id})
                  </span>
                </div>
                {item?.durationInMinutes && (
                  <div className={styles.item_main_duration}>
                    {formatDuration(item?.durationInMinutes)}
                  </div>
                )}
              </div>
            </div>
          }
        />
      </div>
      {actionButtons}
    </div>
  );
};
